window.theme = window.theme || {};

(function($) {
  var $ = jQuery = $;
  $(document).ready(function(e) {
    const store_urls = {
      'EUR': 'https://alaska1795.com',
      'FIN': 'https://alaskabrands.fi',
      'SEK': 'https://alaskabrands.se',
      'DEU': 'https://alaska1795.de'
    };

    var admin_url_fi = 'https://alaskabrandsfi.myshopify.com';
    var admin_url_en = 'https://alaskabrands.myshopify.com';
    var admin_url_se = 'https://alaskabrandsse.myshopify.com';
    var admin_url_de = 'https://alaska-brands-germany.myshopify.com';

    if (window.location.origin === admin_url_fi
            || window.location.origin === admin_url_en
            || window.location.origin === admin_url_se
            || window.location.origin === admin_url_de
    )
    {
      return;
    }

    // check_url_params(store_urls); // Commented out - ignore URL parameters per requirements

    // Delete existing store_language cookie if it exists
    if (get_cookies_array()['store_language'] !== undefined) {
      delete_store_language_cookie();
    }
    
    // Fix flag display based on current domain
    fix_flag_display_based_on_domain();
    
    // Modal will only show when user clicks language selector
    // $('.js-modal-open-currency-modal').trigger('click'); // Removed automatic trigger
    
    // Commented out automatic redirect based on cookie
    // if (get_cookies_array()['store_language'] === undefined || get_cookies_array()['store_language'] === '') {
    //   $('.js-modal-open-currency-modal').trigger('click');
    // } else {
    //   get_url_and_redirect(store_urls);
    // }

    $('.currency-options__btn').on('click', function(e) {
      // document.cookie = cookie_value($(this).attr('data-value')); // Commented out - no cookie storage per requirements
      var selected_language = $(this).attr('data-value');
      return get_url_and_redirect(store_urls, selected_language);
    });

    manage_incoming_products_message();
  });
})(theme.jQuery);

function get_cookies_array() {
  let cookies = {};

  if (document.cookie && document.cookie !== '') {
    let split = document.cookie.split(';');
    for (let i = 0; i < split.length; i++) {
      let name_value = split[i].split('=');
      name_value[0] = name_value[0].replace(/^ /, '');
      cookies[decodeURIComponent(name_value[0])] = decodeURIComponent(
              name_value[1]);
    }
  }

  return cookies;
}


// Commented out URL parameter processing per requirements - ignore store_language URL parameter
// function check_url_params(store_urls) {
//   var urlParams = new URLSearchParams(window.location.search);
//   if (urlParams.has('store_language')) {
//     var lang = urlParams.get('store_language');
//     if (lang == 'EUR' || lang == 'FIN' || lang == 'SEK' || lang == 'NOK' || lang == 'DEU') {
//       $('.currency-options__btn[data-value=' + lang + ']').trigger('click');
//       document.cookie = cookie_value(lang);
//     } else {
//       var splited_lang = window.location.origin.split('.');
//
//       if (splited_lang[splited_lang.length - 1] == 'com') {
//         lang = 'EUR';
//       } else if (splited_lang[splited_lang.length - 1] == 'fi') {
//         lang = 'FIN';
//       } else if (splited_lang[splited_lang.length - 1] == 'se') {
//         lang = 'SEK';
//       } else if (splited_lang[splited_lang.length - 1] == 'de') {
//         lang = 'DEU';
//       }
//
//       $('.currency-options__btn[data-value=' + lang + ']').trigger('click');
//       document.cookie = cookie_value(lang);
//     }
//
//     return get_url_and_redirect(store_urls);
//   }
// }

function get_url_and_redirect(store_urls, chosen_language) {
  var current_base_url = window.location.origin;
  var url_path = '';
  var body = $('body');
  if (body.hasClass('burrel-body')) {
    url_path = '/pages/burrel';
  }
  // Use passed language parameter instead of cookie
  // var chosen_language = get_cookies_array()['store_language']; // Commented out - no longer using cookies
  if (current_base_url !== store_urls[chosen_language]) {
    window.location.replace(store_urls[chosen_language] + url_path); // Removed query string per requirements
  }
}

// Commented out cookie_value function as we no longer store cookies
// function cookie_value(data) {
//   return 'store_language=' + data + ';expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;secure;SameSite=none';
// }

// Function to delete store_language cookie
function delete_store_language_cookie() {
  document.cookie = 'store_language=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;secure;SameSite=none';
}

function fix_flag_display_based_on_domain() {
  var current_domain = window.location.origin;
  var correct_flag_code = '';
  
  // Determine correct flag based on domain
  if (current_domain.includes('alaskabrands.fi')) {
    correct_flag_code = 'FIN';
  } else if (current_domain.includes('alaskabrands.se')) {
    correct_flag_code = 'SEK';
  } else if (current_domain.includes('alaska1795.com')) {
    correct_flag_code = 'EUR';
  } else if (current_domain.includes('alaska1795.de')) {
    correct_flag_code = 'DEU';
  }
  
  // Update only the currency picker flag (header), not modal flags
  if (correct_flag_code) {
    $('.currency-picker__btn .currency-flag').attr('data-flag', correct_flag_code);
  }
}

function manage_incoming_products_message() {
  $('.product-single__form input').on('change', function(e) {
    var selected_options = [];
    $('input:checked').each(function() {
      selected_options.push(jquery_handleize_string($(this).val()));
    });
    var selected_option_class = '.' + selected_options.join('-');
    console.log(selected_option_class);
    var incoming_div_with = $('.incoming-inventory-metafields' + selected_option_class);
    var incoming_div_without = $('.incoming-inventory-metafields:not(' + selected_option_class + ')');
    incoming_div_with.show();
    incoming_div_without.hide();
  });
}

function jquery_handleize_string(str) {
  str = str.toLowerCase();
  var toReplace = ['"', '\'', '\\', '(', ')', '[', ']'];
  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], '');
  }
  str = str.replace(/\W+/g, '-');
  if (str.charAt(str.length - 1) == '-') {
    str = str.replace(/-+\z/, '');
  }
  if (str.charAt(0) == '-') {
    str = str.replace(/\A-+/, '');
  }

  return str;
};
